import styles from './ImageCardSection.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

class ImageCardSection extends CustomComponent {
    constructor() {
        super();
        this.customStyle = styles;
    }

    render() {
        const container = document.createElement('div');
        container.innerHTML = `
            <div class="heading base-grid">
                <div class="overline"></div>
                <div class="title"></div>
                <div class="subtitle"></div>
            </div>
            <div class="body">
                <slot></slot>
            </div>
      `;
        // Clone Slots into container to prevent styling issues
        this.cloneSlotContentIntoContainer(container.querySelector('.overline'), 'overline');
        this.cloneSlotContentIntoContainer(container.querySelector('.title'), 'title');
        this.cloneSlotContentIntoContainer(container.querySelector('.subtitle'), 'subtitle');
        const heading = container.querySelector('.heading');
        if(heading.children.length === 0) {
            heading.remove();
        }
        return container;
    }

}

customElements.define('nxt-image-card-section', ImageCardSection);
